"use client"

import type React from "react"
import { useState, useEffect } from "react"
import { toast } from "react-toastify"
import BuilderService from "../../services/BuilderService"
import {Link, useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react"
import GoogleLoginButton from "./GoogleLoginButton"
import { useUserDetails } from '../../../redux/hooks/UserDetails';
import { useTheme } from '../../../redux/hooks/useTheme';
import { motion, Variants } from 'motion/react';
import { Loader } from  './Loader'
import Logo from "../Dashboard/SubComponents/Logo";
import ReCAPTCHAComponent from "../../utils/ReCAPTCHA";
import { Eye, EyeOff } from "lucide-react";

interface SignupResponse {
  success: boolean;
  exists:boolean;
  message?: string;
}


export default function SignUp() {
  const [email, setEmail] = useState<string>("")
  const [agreedToTerms, setAgreedToTerms] = useState<boolean>(false)
  const [showTermsError, setShowTermsError] = useState(false);
  const [isChecking, setIsChecking] = useState<boolean>(false);
  const [isResending, setIsResending] = useState<boolean>(false);
  const [isVerificationSent, setIsVerificationSent] = useState<boolean>(false);
  const [timer, setTimer] = useState<number>(60);
  const [canResend, setCanResend] = useState<boolean>(false);
  const builderService = new BuilderService();
  const { userDetail } = useUserDetails();
  const navigate = useNavigate();
  const { theme } = useTheme();

  const signup = async (email: string): Promise<SignupResponse> => {
    try {
      setIsChecking(true)
      const response = await builderService.signup(email)
      console.log("data1:",response);
      return response;
    } catch (error) {
      console.error("Error checking email:", error)
      toast.error("Error checking email availability")
      return {success:false,exists:false};
    } finally {
      setIsChecking(false)
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email) {
      toast.error("Please enter the email")
      return
    }

    if (!agreedToTerms) {
      setShowTermsError(true);
      setTimeout(() => setShowTermsError(false), 3000);
      return;
    }
    
    try {
      const user = await signup(email);
      if (user && user.success && user.exists) {
        toast.error(`${user.message}`  || "User already exists..",{
          autoClose:2500
        });
        // if (onLoginClick && email) {
           navigate(`/login?email=${encodeURIComponent(email)}`);
        // }
        return;
      }
      if(user && user.success &&  user.exists==false){
         setIsVerificationSent(true);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.")
      setIsVerificationSent(false); 
    }
  }

  const onGoogleSignup = async ()=>{

  }

  const resendEmail = async () => {
    try {
      setIsResending(true);
      setCanResend(false);
      setTimer(60); // Reset timer to 60 seconds
      // Implement resend verification email logic here
      let res  = await builderService.resendVerificationEmail(email);
      console.log("resend email response:",res);
      if(res && res.success){
        toast.success(`${res.message}`);
      }
    } catch (error) {
      toast.error("Failed to resend verification email");
      setCanResend(true); // Allow retry on error
    }
    finally {
      setIsResending(false);
    }
  }
  useEffect(() => {
    if (userDetail) {
      console.log("user loggedin:", userDetail);
      navigate('/');
  }
}, [userDetail, navigate]);


useEffect(() => {
  let interval: NodeJS.Timeout;
  
  if (isVerificationSent && timer > 0) {
    interval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          setCanResend(true);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
  }

  return () => {
    if (interval) {
      clearInterval(interval);
    }
  };
}, [isVerificationSent, timer]);

  if (isVerificationSent) {
    return (
      <div  style={{
         background: `url(${theme.heroSectionImage}) no-repeat`,
      backgroundColor: theme.heroSectionBackgroundGradient,
      backgroundSize:'cover',
      backgroundPosition:'center',
      backgroundRepeat:'no-repeat'
      }} className="flex flex-col min-h-screen items-center justify-center gap-[40px]">

        <motion.div
            className="flex items-center w-[132px] mt-[-120px] sm:w-auto logo-mob"
          >
            <Link to="/">
            {/* <img
              src={theme.heroLogo} // Use src instead of background
              className="h-10 mr-2 md:p-0"
              alt="Advance To Builder"
            />   */}
            <Logo />
            </Link>
          </motion.div>
          <div className="w-full max-w-[480px] md:max-w-[540px] flex justify-center">
 <div className="w-full max-w-md rounded-xl overflow-hidden"
          style={{ }}>
          <div className="flex flex-col items-center p-8 text-center">
           <div className="mb-[29px]">
            <span>
              <img src="https://dlvkyia8i4zmz.cloudfront.net/cfZol7X8TIRsG2UVWIWA_Frame__9_.svg"/>
            </span>
           </div>
            <h2 style={{color:theme.faqQues, fontWeight:600}} className="text-[26px] font-sora mb-[10px]">Verify Your Email!</h2>
            <p style={{fontWeight:400}} className="text-[18px] signup-hm font-inter mb-[32px]">
              We've sent a confirmation link to <b> <span style={{fontWeight:600}} >{email}</span></b>. Please check your inbox and verify to continue.
            </p>
            <button 
             style={{}}
              onClick={resendEmail}
              disabled={isResending || !canResend}
              className={` sign-upbt ${isResending || !canResend ? 'bg-pink-400' : 'bg-pink-500 hover:bg-pink-600'} text-white font-medium rounded-[12px] transition-colors font-inter py-[14px] px-[28px] text-center focus:outline-none`}
            //   className="w-full sign-upbt rounded-[12px] font-inter py-3 text-center focus:outline-none"
            >
              {isResending ? (
                      <Loader text="Resending..." />
                    ) : !canResend ? (
                      `Resend Email (${timer}s)`
                    ) : (
                      "Resend Email"
                    )}
            </button>
          </div>
        </div>
          </div>
       
      </div>
    );
  }

  return (
    <div  style={{
      background: `url(${theme.heroSectionImage}) no-repeat`,
      backgroundColor: theme.heroSectionBackgroundGradient,
      backgroundSize:'cover',
      backgroundPosition:'center',
      backgroundRepeat:'no-repeat'
    }} className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <ReCAPTCHAComponent/>
      <div className="flex flex-col justify-center items-center gap-[50px] ">
      <motion.div
            className="flex items-center mt-[-100px] w-[132px] sm:w-auto logo-mob"
          // whileHover={{ scale: 1.05 }}
          // whileTap={{ scale: 0.95 }}
          >
            <Link to="/">
            {/* <img
              src={theme.heroLogo} // Use src instead of background
              className="h-10 mr-2 md:p-0"
              alt="Advance To Builder"
            /> */}
            <Logo />
              
            </Link>
          </motion.div>
      <div className="sign-up-upr">
      <div
        className="w-full max-w-[480px] rounded-[20px] bg-white p-[20px] sm:p-[32px] md:p-8 shadow-sm signup-p"
        style={{ width: '100%' }}
      >
        <div className="">
          {/* Header */}
          <div className="text-center">
            <h2 style={{ color: theme.mainHeadingOne, fontWeight:600 }} className="text-[22px] font-sora">Join Us Today!</h2>
            <p  style={{color:theme.SubHeadingSubTwo,fontWeight:400}} className="text-[16px] mt-[10px] mb-[24px] font-inter">Create an account and unlock new possibilities.</p>
          </div>

          {/* Form */}
          <form className="" onSubmit={handleSubmit}>
            {/* Email Input */}
            <div className="relative mb-[18px]">
              <div className="absolute p-[15px] flex items-center spborder-r">
                
            <span style={{color:theme.seIcon}}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.7499 15.375H5.24994C2.99994 15.375 1.49994 14.25 1.49994 11.625V6.375C1.49994 3.75 2.99994 2.625 5.24994 2.625H12.7499C14.9999 2.625 16.4999 3.75 16.4999 6.375V11.625C16.4999 14.25 14.9999 15.375 12.7499 15.375Z" stroke="currentColor" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.7501 6.75L10.4026 8.625C9.63006 9.24 8.36256 9.24 7.59006 8.625L5.25006 6.75"  stroke="currentColor" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>

              </div>
              <input
                type="email"
                placeholder="Enter email"
                className="w-full sp-border signout-h rounded-[12px] border py-3 pl-[55px] pr-4 focus:outline-none"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
               
              />
            </div>

            {/* Terms Checkbox */}
            
            <div className="flex flex-col">
  <div style={{alignItems:'flex-start'}} className="flex items-center gap-[8px] mb-[32px]">
    <div className="flex items-center">
      <input 
        id="terms"
        type="checkbox"
        className={`h-[14px] w-[14px] green-checkbox rounded-[4px] mt-[3px] border-gray-300 focus:ring-0 ${
          showTermsError ? 'border-pink-500 border-2' : ''
        }`}
        checked={agreedToTerms}
        onChange={(e) => {
          setAgreedToTerms(e.target.checked);
          if (e.target.checked) {
            setShowTermsError(false);
          }
        }}
      />
    </div>
    <div className="font-inter flex">
      <label style={{color: showTermsError ? theme.errorColor : theme.seIcon, fontWeight:400}} 
        htmlFor="terms" 
        className="text-[12px]"
      >
        By signing up you agree to Tool Builder's{" "}
        <a 
          href="#" 
          className="text-pink-500 hover:underline"
          onClick={(e) => {
            e.preventDefault();
            navigate('/terms-of-service');
          }}
        >
          <span style={{fontWeight:400}} className="gradient-text">terms and conditions.</span>
        </a>
      </label>
    </div>
  </div>
  {showTermsError && (
    <div className="flex items-center text-pink-500 text-[12px] mb-[7px] font-inter">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-1">
        <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 8V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.995 16H12.004" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      Please accept the terms and conditions to continue
    </div>
  )}
</div>

            {/* Sign Up Button */}
            <button
              type="submit"
              className="w-full sign-upbt rounded-[12px] font-inter py-3 text-center focus:outline-none"
             
            >
                {isChecking ? <Loader text="Loading..." /> : "Sign Up"}

            </button>

            {/* Divider */}
            <div className="relative mt-[14px] mb-[14px] flex items-center">
              <div className="flex-grow border-t sp-border"></div>
              <span style={{ color:theme.seIcon}} className="mx-4 font-inter flex-shrink">Or</span>
              <div className="flex-grow border-t sp-border"></div>
            </div>

            {/* Google Button */}
           
             <GoogleLoginButton />
             
          </form>

          {/* Login Link */}
          <div className="text-center mt-[14px] text-sm ">
           <span style={{fontWeight:400 }} className="s-suggestion font-inter text-[12px]"> Already have an account?{" "}</span>
            <button  className="hover:underline"
                 onClick={() => navigate('/login')}
             >
             <span style={{fontWeight:400 }}  className="gradient-text font-inter text-[12px] hover:underline hover:decoration-[#ff3ab6]"> Log In</span>
            </button>
          </div>
        </div>
      </div>
      </div>
      </div>
    </div>
  )
}

//  LOGIN + SIGNUP COMBINE

// export default function SignUp() {
//   const [email, setEmail] = useState<string>("")
//   const [agreedToTerms, setAgreedToTerms] = useState<boolean>(false)
//   const [showTermsError, setShowTermsError] = useState(false);
//   const [isChecking, setIsChecking] = useState<boolean>(false);
//   const [isResending, setIsResending] = useState<boolean>(false);
//   const [isVerificationSent, setIsVerificationSent] = useState<boolean>(false);
//   const [timer, setTimer] = useState<number>(60);
//   const [canResend, setCanResend] = useState<boolean>(false);
//   const builderService = new BuilderService();
//   const { userDetail } = useUserDetails();
//   const navigate = useNavigate();
//   const { theme } = useTheme();
//   const [showPassword,setShowPassword] = useState<boolean>(false)
//   const [password,setPassword]= useState<string>('')
//   const [emailAlreadyExists, setEmailAlreadyExists] = useState<boolean>(false);
//   const signup = async (email: string): Promise<SignupResponse> => {
//     try {
//       setIsChecking(true)
//       const response = await builderService.signup(email)
//       console.log("data1:",response);
//       return response;
//     } catch (error) {
//       console.error("Error checking email:", error)
//       toast.error("Error checking email availability")
//       return {success:false,exists:false};
//     } finally {
//       setIsChecking(false)
//     }
//   }

//   async function handleLogin(){
//       setIsChecking(true)
//       if(!email || !password) {
//           toast.error("Please enter the email and password")
//           return
//         }
//         try {
//         const response = await builderService.login(
//           email,
//           password
//         );
//         if (response.success) {
//         await new Promise((r)=>setTimeout(r,500))
//          const sessionValid = await builderService
//           .checkSessionValidity()
   
//           .then((r) =>{
//             return r?.data?.exists === true
//           })
//           .catch((err) => {
//             console.error('Session invalid:', err);
//             return false;
//           });

//         if (!sessionValid) {
//           toast.warn('Third-party cookies are blocked. Please enable them to continue.');
//           return;
//         }

//         toast.success('Login successful!');
//         navigate('/');
//       } 
//     } catch (error: any) {
//       toast.error(error && error.response  && error.response.data && error.response.data.message);
//     }finally{
//       setIsChecking(false)
//     }
//   }

//   async function handleSignUp(){
//      try {
//       const user = await signup(email);
//       console.log(user,123)
//       if (user && user.success && user.exists) {
//         setEmailAlreadyExists(true);  
//         // toast.error(`${user.message}`  || "User already exists..");
//         // if (onLoginClick && email) {
//           //  navigate(`/login?email=${encodeURIComponent(email)}`);
//         // }
//         return;
//       }
//       if(user && user.success &&  user.exists==false){
//          setIsVerificationSent(true);
//       }
//     } catch (error) {
//       toast.error("Something went wrong. Please try again.")
//       setIsVerificationSent(false); 
//     }
//   }

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault()
//     if (!email) {
//       toast.error("Please enter the email")
//       return
//     }
//      //  validate email
//     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     if (!emailRegex.test(email)) {
//       toast.error("Please enter a valid email address");
//       return { success: false, exists: false, message: "Invalid email" };
//     }

//     // if (!agreedToTerms) {
//     //   setShowTermsError(true);
//     //   setTimeout(() => setShowTermsError(false), 3000);
//     //   return;
//     // }

//     if(emailAlreadyExists){
//       if(!email || !password) return toast.error("Please enter the email and password");
//       handleLogin()
//     }else{ 
//       if(!email) return toast.error("Please enter the email");
//       handleSignUp()
//     }
//   }

//   const onGoogleSignup = async ()=>{

//   }

//   const resendEmail = async () => {
//     try {
//       setIsResending(true);
//       setCanResend(false);
//       setTimer(60); // Reset timer to 60 seconds
//       // Implement resend verification email logic here
//       let res  = await builderService.resendVerificationEmail(email);
//       console.log("resend email response:",res);
//       if(res && res.success){
//         toast.success(`${res.message}`);
//       }
//     } catch (error) {
//       toast.error("Failed to resend verification email");
//       setCanResend(true); // Allow retry on error
//     }
//     finally {
//       setIsResending(false);
//     }
//   }
//   useEffect(() => {
//     if (userDetail) {
//       console.log("user loggedin:", userDetail);
//       navigate('/');
//   }
// }, [userDetail, navigate]);


// useEffect(() => {
//   let interval: NodeJS.Timeout;
  
//   if (isVerificationSent && timer > 0) {
//     interval = setInterval(() => {
//       setTimer((prevTimer) => {
//         if (prevTimer <= 1) {
//           setCanResend(true);
//           return 0;
//         }
//         return prevTimer - 1;
//       });
//     }, 1000);
//   }

//   return () => {
//     if (interval) {
//       clearInterval(interval);
//     }
//   };
// }, [isVerificationSent, timer]);




//   if (isVerificationSent) {
//     return (
//       <div  style={{
//          background: `url(${theme.heroSectionImage}) no-repeat`,
//       backgroundColor: theme.heroSectionBackgroundGradient,
//       backgroundSize:'cover',
//       backgroundPosition:'center',
//       backgroundRepeat:'no-repeat'
//       }} className="flex flex-col min-h-screen items-center justify-center gap-[40px]">

//         <motion.div
//             className="flex items-center w-[132px] mt-[-120px] sm:w-auto logo-mob"
//           >
//             <Link to="/">
//             {/* <img
//               src={theme.heroLogo} // Use src instead of background
//               className="h-10 mr-2 md:p-0"
//               alt="Advance To Builder"
//             />   */}
//             <Logo />
//             </Link>
//           </motion.div>
//           <div className="w-full max-w-[480px] md:max-w-[540px] flex justify-center">
//  <div className="w-full max-w-md rounded-xl overflow-hidden"
//           style={{ }}>
//           <div className="flex flex-col items-center p-8 text-center">
//            <div className="mb-[29px]">
//             <span>
//               <img src="https://dlvkyia8i4zmz.cloudfront.net/cfZol7X8TIRsG2UVWIWA_Frame__9_.svg"/>
//             </span>
//            </div>
//             <h2 style={{color:theme.faqQues, fontWeight:600}} className="text-[26px] font-sora mb-[10px]">Verify Your Email!</h2>
//             <p style={{fontWeight:400}} className="text-[18px] signup-hm font-inter mb-[32px]">
//               We've sent a confirmation link to <span style={{fontWeight:600}} >{email}</span>. Please check your inbox and verify to continue.
//             </p>
//             <button 
//              style={{}}
//               onClick={resendEmail}
//               disabled={isResending || !canResend}
//               className={` sign-upbt ${isResending || !canResend ? 'bg-pink-400' : 'bg-pink-500 hover:bg-pink-600'} text-white font-medium rounded-[12px] transition-colors font-inter py-[14px] px-[28px] text-center focus:outline-none`}
//             //   className="w-full sign-upbt rounded-[12px] font-inter py-3 text-center focus:outline-none"
//             >
//               {isResending ? (
//                       <Loader text="Resending..." />
//                     ) : !canResend ? (
//                       `Resend Email (${timer}s)`
//                     ) : (
//                       "Resend Email"
//                     )}
//             </button>
//           </div>
//         </div>
//           </div>
       
//       </div>
//     );
//   }

//   return (
//     <div  style={{
//       background: `url(${theme.heroSectionImage}) no-repeat`,
//       backgroundColor: theme.heroSectionBackgroundGradient,
//       backgroundSize:'cover',
//       backgroundPosition:'center',
//       backgroundRepeat:'no-repeat'
//     }} className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
//       <ReCAPTCHAComponent/>
//       <div className="flex flex-col justify-center items-center gap-[50px] ">
//       <motion.div
//             className="flex items-center mt-[-100px] w-[132px] sm:w-auto logo-mob"
//           // whileHover={{ scale: 1.05 }}
//           // whileTap={{ scale: 0.95 }}
//           >
//             <Link to="/">
//             {/* <img
//               src={theme.heroLogo} // Use src instead of background
//               className="h-10 mr-2 md:p-0"
//               alt="Advance To Builder"
//             /> */}
//             <Logo />
              
//             </Link>
//           </motion.div>
//       <div className="sign-up-upr">
//       <div
//         className="w-full max-w-[480px] rounded-[20px] bg-white p-[20px] sm:p-[32px] md:p-8 shadow-sm signup-p"
//         style={{ width: '100%' }}
//       >
//         <div className="">
//           {/* Header */}
//             <div className="text-center">
//             <h2 style={{ color: theme.mainHeadingOne, fontWeight:600 }} className="text-[22px] font-sora">{emailAlreadyExists ? 'Welcome back!' :'Sign up with your email'}</h2>
//             <p style={{color:theme.SubHeadingSubTwo,fontWeight:400}} className="text-[16px] mt-[10px] mb-[24px] font-inter">{emailAlreadyExists ? 'Log in' :'Sign up'} and continue crafting powerful tools.</p>
//           </div>

//           {/* Form */}
//           <form className="" onSubmit={handleSubmit}>
//             {/* Email Input */}
//             <div className="relative mb-[18px]">
//               <div className="absolute p-[15px] flex items-center spborder-r">
                
//             <span style={{color:theme.seIcon}}>
//               <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//                 <path d="M12.7499 15.375H5.24994C2.99994 15.375 1.49994 14.25 1.49994 11.625V6.375C1.49994 3.75 2.99994 2.625 5.24994 2.625H12.7499C14.9999 2.625 16.4999 3.75 16.4999 6.375V11.625C16.4999 14.25 14.9999 15.375 12.7499 15.375Z" stroke="currentColor" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
//                 <path d="M12.7501 6.75L10.4026 8.625C9.63006 9.24 8.36256 9.24 7.59006 8.625L5.25006 6.75"  stroke="currentColor" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
//                 </svg>
//             </span>

//               </div>
//               <input
//                 type="email"
//                 placeholder="Enter email"
//                 className="w-full sp-border signout-h rounded-[12px] border py-3 pl-[55px] pr-4 focus:outline-none"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
               
//               />
//             </div>

//           {
//             emailAlreadyExists && (
//               <>
//                {/* Password Input */}
//             <div className="relative mb-[18px]">
//               <div className="absolute inset-y-0 p-[15px] flex items-center spborder-r">
//                 <span style={{color:theme.seIcon}}>
               
//                 <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
//                 <path d="M4.5 7.5V6C4.5 3.5175 5.25 1.5 9 1.5C12.75 1.5 13.5 3.5175 13.5 6V7.5" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
//                 <path d="M9 13.875C10.0355 13.875 10.875 13.0355 10.875 12C10.875 10.9645 10.0355 10.125 9 10.125C7.96447 10.125 7.125 10.9645 7.125 12C7.125 13.0355 7.96447 13.875 9 13.875Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
//                 <path d="M12.75 16.5H5.25C2.25 16.5 1.5 15.75 1.5 12.75V11.25C1.5 8.25 2.25 7.5 5.25 7.5H12.75C15.75 7.5 16.5 8.25 16.5 11.25V12.75C16.5 15.75 15.75 16.5 12.75 16.5Z" stroke="currentColor" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
//                 </svg>

//                 </span>
//               </div>
//               <input
//                 type={showPassword ? "text" : "password"}
//                 placeholder="Enter password"
//                 className="w-full rounded-lg border sp-border signout-h rounded-[12px] py-[14px] pl-[55px] pr-10 focus:outline-none"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//               />
//               <button
//                 type="button"
//                 className="absolute inset-y-0 right-3 flex items-center"
//                 onClick={() => setShowPassword(!showPassword)}
//               >
//                 {showPassword ? (
//                   <span style={{color:theme.seIcon}}>
//                   <Eye className="h-5 w-5 text-gray-400" />
//                   </span>
                 
//                 ) : (
//                   <span style={{color:theme.seIcon}}>
//                      <EyeOff className="h-5 w-5 text-gray-400" />
//                   </span>
//                 )}
//               </button>
//             </div>
//                 {/* Forgot Password Link */}
//             <div className="flex justify-end">
//               <button style={{fontWeight:500 }}  type="button" className="text-[12px] mt-[-8px] mb-[8px] hover:underline hover:decoration-[#ff3ab6]" onClick={()=>navigate('/forgotPassword')}>
//                 <span className="gradient-text font-inter">Forgot Password?</span>
//               </button>
//             </div>
//               </>
//             )
//           }



//             {/* Sign Up Button */}
//             <button
//               type="submit"
//               className="w-full sign-upbt rounded-[12px] font-inter py-3 text-center focus:outline-none"
             
//             >
//                 {isChecking ? <Loader text="Loading..." /> : emailAlreadyExists ? 'Sign In' : 'Get Started'}

//             </button>

//             {/* Divider */}
//             <div className="relative mt-[14px] mb-[14px] flex items-center">
//               <div className="flex-grow border-t sp-border"></div>
//               <span style={{ color:theme.seIcon}} className="mx-4 font-inter flex-shrink">Or</span>
//               <div className="flex-grow border-t sp-border"></div>
//             </div>

//             {/* Google Button */}
           
//              <GoogleLoginButton />
             
//           </form>

//           {/* Login Link */}
//           {/* <div className="text-center mt-[14px]  text-sm ">
//            <span style={{fontWeight:400 }} className="s-suggestion font-inter text-[12px]"> Already have an account?{" "}</span>
//             <button  className="hover:underline"
//                  onClick={() => navigate('/login')}
//              >
//              <span style={{fontWeight:400 }}  className="gradient-text font-inter text-[12px] hover:underline hover:decoration-[#ff3ab6]"> Log In</span>
//             </button>
//           </div> */}

//              <div className="flex flex-col mt-[20px]">
//   <div style={{alignItems:'flex-start'}} className="flex items-center gap-[8px] ">
//     {/* <div className="flex items-center">
//       <input 
//         id="terms"
//         type="checkbox"
//         className={`h-[14px] w-[14px] green-checkbox rounded-[4px] mt-[3px] border-gray-300 focus:ring-0 ${
//           showTermsError ? 'border-pink-500 border-2' : ''
//         }`}
//         checked={agreedToTerms}
//         onChange={(e) => {
//           setAgreedToTerms(e.target.checked);
//           if (e.target.checked) {
//             setShowTermsError(false);
//           }
//         }}
//       />
//     </div> */}
//     <div className="font-inter flex">
//       <label style={{color: showTermsError ? theme.errorColor : theme.seIcon, fontWeight:400}} 
//         htmlFor="terms" 
//         className="text-[12px]"
//       >
//         By signing up you agree to Tool Builder's{" "}
//         <a 
//           href="#" 
//           className="text-pink-500 hover:underline"
//           onClick={(e) => {
//             e.preventDefault();
//             navigate('/terms-of-service');
//           }}
//         >
//           <span style={{fontWeight:400}} className="gradient-text">terms and conditions.</span>
//         </a>
//       </label>
//     </div>
//   </div>
//   {/* {showTermsError && (
//     <div className="flex items-center text-pink-500 text-[12px] mb-[7px] font-inter">
//       <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-1">
//         <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//         <path d="M12 8V13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//         <path d="M11.995 16H12.004" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//       </svg>
//       Please accept the terms and conditions to continue
//     </div>
//   )} */}
// </div>
//         </div>
//       </div>
//       </div>
//       </div>
//     </div>
//   )
// }


